var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comp-im-checkbox" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.modelVal,
          expression: "modelVal",
        },
      ],
      staticClass: "label im-checkbox-ele",
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.modelVal)
          ? _vm._i(_vm.modelVal, null) > -1
          : _vm.modelVal,
      },
      on: {
        change: function ($event) {
          var $$a = _vm.modelVal,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.modelVal = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.modelVal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.modelVal = $$c
          }
        },
      },
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "label",
        class: _vm.labelClass,
        on: { click: _vm.checked },
      },
      [_c("span", { staticClass: "checkicon iconfont icon-checked-light" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }